// https://www.npmjs.com/package/react-slideshow-image
import React from 'react';
import { Slide } from 'react-slideshow-image';
import './SlidesStyles.css'
import 'react-slideshow-image/dist/styles.css'
import EachSlideMultiPage from './EachSlideMultiPage';


const properties = {
  duration: 7000,
  transitionDuration: 500,
  infinite: true,
  indicators: true,
  arrows: true
}

const SlideshowMultiPg = (type) => {

    return (
        <div className='slideshow-supercontainer'>
        <div className='slideshow-container'>

      <h3 className='projType'>Multi-Feature-Apps</h3>
      
      <div>
      <Slide {...properties}>
      {/* {for(projNo in )} */}
      <EachSlideMultiPage projNo={0}/>
      <EachSlideMultiPage projNo={1}/>
      <EachSlideMultiPage projNo={2}/>
      <EachSlideMultiPage projNo={3}/>
      <EachSlideMultiPage projNo={4}/>
      {/* <EachSlideMultiPage projNo={5}/> */}
      {/* <EachSlideMultiPage projNo={2}/>
      <EachSlideMultiPage projNo={4}/>
      <EachSlideMultiPage projNo={1}/>
      <EachSlideMultiPage projNo={5}/>
      <EachSlideMultiPage projNo={6}/>
      <EachSlideMultiPage projNo={7}/> */}
    
      </Slide>
      
      </div>
      </div>
      </div>
    )
}

export default SlideshowMultiPg